module.exports = __webpack_public_path__ + "de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/de.svg
// module id = 515
// module chunks = 0